import { apiRequest } from "@/api";
import axios from "axios";

const state = {};

const mutations = {};

const actions = {
  SIMILARITY_UPLOAD: ({}, product) =>
    new Promise((resolve, reject) => {
      axios
        .get("https://sauron.cleed.ai:443/api/lookup", {
          params: {
            product_id: product.product_id,
            store_id: product.store_id,
            shift: 0,
          },
        })
        .then(({ data }) => {
          console.log("similarity result", data);
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    }),
};
export default {
  state,
  actions,
  mutations,
};
